export var icon = {
    size: {
        tiny: '12px',
        small: '16px',
        default: '24px',
        large: '32px'
    }
};
//# sourceMappingURL=icon.js.map